import { IconProp } from "@fortawesome/fontawesome-svg-core"
import {
  faBus,
  faCarCrash,
  faCarWrench,
  faHand,
  faMemoPad,
  faPersonFallingBurst,
  faScreenUsers,
  faThoughtBubble,
  faTrafficLight
} from "@fortawesome/pro-solid-svg-icons"
import { TemplateSettings } from "pages/deviation/deviation.interface"
import { FormTemplateKey } from "helpers/FormTemplate/FormTemplateKey";

export const getTemplateSettings = (key: string) => {

  switch (key) {
    case FormTemplateKey.VehicleDamage:
      return {
        defaultValue: "Vehicle damage",
        label: "global.features.title.deviationvehicledamage",
        icon: faCarCrash as IconProp,
        description: "global.features.description.deviationvehicledamage"
      } as TemplateSettings
    case FormTemplateKey.ThreatsAndViolence:
      return {
        defaultValue: "Threats and violence",
        label: "global.features.title.deviationthreatsandviolence",
        icon: faHand as IconProp,
        description: "global.features.description.deviationthreatsandviolence"
      } as TemplateSettings
    case FormTemplateKey.TrafficAndCustomerInfo:
      return {
        defaultValue: "Traffic and customer info",
        label: "global.features.title.deviationtrafficandcustomerinfo",
        icon: faTrafficLight as IconProp,
        description: "global.features.description.deviationtrafficandcustomerinfo"
      } as TemplateSettings
    case FormTemplateKey.VastanhedeTrafficDisruption:
      return {
        defaultValue: "Västanhede traffic disruption",
        label: "deviation.traffic_disruption_customer_deviation",
        icon: faTrafficLight as IconProp,
        description: "global.features.description.vastanhede_traffic_disruption"
      } as TemplateSettings
    case FormTemplateKey.WorkingEnvironment:
      return {
        defaultValue: "Working environment",
        label: "global.features.title.deviationworkingenvironment",
        icon: faScreenUsers as IconProp,
        description: "global.features.description.deviationworkingenvironment"
      } as TemplateSettings
    case FormTemplateKey.VastanhedePersonalInjuries:
      return {
        defaultValue: "Västanhede incidents and personal injuries",
        label: "deviation.incidents_personal_injuries",
        icon: faPersonFallingBurst as IconProp,
        description: "global.features.description.vastanhedeincidentpersonalinjuries"
      }
    case FormTemplateKey.VastanhedeWorkingEnvironment:
      return {
        defaultValue: "Västanhede working environment",
        label: "deviation.vastanhede_working_environment",
        icon: faScreenUsers as IconProp,
        description: "global.features.description.deviationworkingenvironment"
      }
    case FormTemplateKey.TrafficLog:
      return {
        defaultValue: "Traffic log",
        label: "global.features.title.deviationtrafficlog",
        icon: faMemoPad as IconProp,
        description: ""
      } as TemplateSettings
    case FormTemplateKey.SuggestionBox:
      return {
        defaultValue: "Suggestion box",
        label: "global.features.title.deviationsuggestionbox",
        icon: faThoughtBubble as IconProp,
        description: ""
      } as TemplateSettings
    case FormTemplateKey.GotlandSchoolBus:
      return {
        defaultValue: "Incidentrapport skolskjuts",
        label: "global.features.title.deviationgotlandschoolbus",
        icon: faBus as IconProp,
        description: ""
      } as TemplateSettings
    case "issue_reports":
      return {
        defaultValue: "Issue reports",
        label: "global.features.title.issuereports",
        icon: faCarWrench as IconProp,
        description: ""
      } as TemplateSettings
    default:
      return
  }
}
